export default {
  SEARCH: {
    REQUEST: 'REQUEST_SEARCH_USERS',
    RECEIVE: 'RECEIVE_SEARCH_USERS',
    FAIL: 'FAIL_SEARCH_USERS',
    CLEAR: 'CLEAR_SEARCH_USERS'
  },
  GET: {
    REQUEST: 'REQUEST_GET_USERS',
    RECEIVE: 'RECEIVE_GET_USERS',
    FAIL: 'FAIL_GET_USERS'
  }
}
